export class exceededhourBO {
    orderColumn: string = "Name";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    employeeId: string ="00000000-0000-0000-0000-000000000000";
    startDate: string | null;;
    agencyId: string = "00000000-0000-0000-0000-000000000000";
    field: string = "Name";
    value: string = "";
    matchCase: boolean;
    operator: string = "contains";
    type: string = "string";
    locationId: string = "00000000-0000-0000-0000-000000000000";
}

export class UploadLeieBO {
    fileName: string;
    file: string;
}

export class GetListBO {
    spendownfilter: boolean | null;
    ptype: number | null;
    role: string;
    user: number | null;
    menuID:string = "00000000-0000-0000-0000-000000000000";
    parentMenuID: string = "00000000-0000-0000-0000-000000000000";
    searchColumn: string;
    searchText: string;
    orderColumn: string = "id";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencydateFilterType: number | null;
    listId: string = "00000000-0000-0000-0000-000000000000";
    lovCode:string = "00000000-0000-0000-0000-000000000000";
    userId: string = "00000000-0000-0000-0000-000000000000";
    field: string = "id";
    value: string = "0";
    matchCase: boolean = false;
    operator: string = "greaterthanorequal";
    type: string = "number";
    locationId: string = "00000000-0000-0000-0000-000000000000";
    isEvv: boolean;
}
export class claimdashboardreturnBO {
    paidtotal: number;
    progresstotal: number;
    deniedtotal: number;
    partialypaidtotal: number;
    paidAmout: number;
    deniedAmout: number;
    partialypaidAmount: number;
    progressAmount: number;
}

// export class ClaimdashboardBO {
export class ClaimdashboardBO {
    groupId: string = "00000000-0000-0000-0000-000000000000";
    payorId: string = "00000000-0000-0000-0000-000000000000";;
    agencyId: string = "00000000-0000-0000-0000-000000000000";;
    locationId:string = "00000000-0000-0000-0000-000000000000";;
    is837I: boolean;
    claimStatus: string;
    fromDate: string;
    toDate: string;
    filterType:boolean=false;
    DateFilterType:boolean=false;

}


export class GetExpiringAuthListBO {
    orderColumn: string = "clientName";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyId:string = "00000000-0000-0000-0000-000000000000";
    field: string = "clientName";
    value: string = "";
    matchCase: boolean;
    operator: string = "contains";
    type: string = "string";
    locationId: string = "00000000-0000-0000-0000-000000000000";
    fromDate: string | null;
    toDate: string | null;
}

export class GetDashboardHoursDetailsBO {
    start: string | null;
    end: string | null;
    employee: string ;
    client: string;
    payor: string;
    service: string;
    agencyId: string = "00000000-0000-0000-0000-000000000000";
    status: number;
    orderColumn: string="employeeName";
    orderType: string = "asc";
    pageitems: number = 10;
    currentpage: number = 1;
    field: string = "employeeName";
    value: string = "";
    matchCase: boolean=false;
    operator: string = "contains";
    type: string = "string";
    locationLid: string = "00000000-0000-0000-0000-000000000000";
   
}

export class CollapseBo
{
    EXPBOOL:boolean=false;
    EXPBOOL1:boolean=false;
    EXPBOOL2:boolean=false;
    EXPBOOL3:boolean=false;
    EXPBOOL4:boolean=false;
    EXPBOOL5:boolean=false;
    EXPINACTIVEBOOL:boolean=false;
    ComingDueBool:boolean=false;
    Excludedbool:boolean=false;
    viewHousingorHoursChart:boolean=false;
    ClientcountperZipcodeList:boolean=false;
    EXPBOOLEXCEED:boolean=false;
}

export class getEmployeeBO {
    agencyId: string = "00000000-0000-0000-0000-000000000000";
    orderColumn: string="zipcode";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpage: number = 1;
    field: string = "zipcode";
    value: string = "";
    matchCase: boolean=false;
    operator: string = "contains";
    type: string = "string";
    locationLid: string = "00000000-0000-0000-0000-000000000000";
}

export class gettimesheetBO {
    start: string | null;
    end: string | null;
    employee: string = "00000000-0000-0000-0000-000000000000";
    client: number | null;
    payor: number | null;
    currentpage: number=1;
    pageitems: number=10;
    agencyId: string = "00000000-0000-0000-0000-000000000000";
    status: string ;
    orderColumn: string="clientName";
    orderType: string="asc";
    field: string="clientName";
    value: string="";
    matchCase: boolean;
    operator: string="contains";
    type: string="string";
    clientstatus: string="Expired SA";
    locationLid:string = "00000000-0000-0000-0000-000000000000";
    dateFilterType: string;

}

export class columnWidth {
    column: string = "";
    width: number = 0;
}

export class exportBO {
    startDate : string|null;
    endDate : string|null;
    isOver : boolean;
    referralStatus : string ;
}
